import { typedGql } from '@zeus/typedDocumentNode'

export const GQL_MY_STATS_NOTICE = typedGql('query')({
  myStatsNotice: {
    status: true,
    acknowledgedAt: true,
    version: true,
    currentVersion: true,
    needsAcknowledgement: true,
  },
})

export const GQL_ACKNOWLEDGE_STATS_NOTICE = typedGql('mutation')({
  acknowledgeStatsNotice: {
    status: true,
    acknowledgedAt: true,
    version: true,
    currentVersion: true,
    needsAcknowledgement: true,
  },
})
